import React from "react";

import { ConditionalSwiper } from "../../../components/shared/conditionalSwiper";
import { useBreakpoint } from "../../../hooks/useBreakpoint";
import CtaButton from "../../shared/buttons/ctaButton";
import ItineraryCard from "../../cards/itineraryCard";

const ProgramJourneysItinerary = ({
  itineraryDetails,
  setBrochureDownloadModal
}) => {
  const breakpoint = useBreakpoint();

  return (
    <>
      <section className="w-full mr-auto border-t border-gray-standard md:border-black-quaternary tab-content">
        <div className="pt-8 md:pt-12 md:pb-4">
          <h6
            className="font-light text-generic-text planet:font-bold text-xl md:text-xlrg-sm planet:!text-white"
            dangerouslySetInnerHTML={{ __html: itineraryDetails?.title }}
          />
          <div
            className="pb-7 pt-2 text-mob md:text-base text-generic-text planet:text-gray-generic"
            dangerouslySetInnerHTML={{ __html: itineraryDetails?.description }}
          />

          <div className="grid grid-cols-1 gap-4 planet:gvi-light-gray-text text-sm">
            <ConditionalSwiper
              condition={breakpoint === "xs"}
              slidesPerView={1.25}
              spaceBetween={10}
              centeredSlides={false}
              className="h-full w-full"
            >
              {itineraryDetails?.itinerary_list?.map((itinerary, idx) => {
                return (
                  <ItineraryCard
                    key={`itinerary-${idx}`}
                    title={itinerary?.itineraryItemTitle || ""}
                    itineraryUnit={itinerary?.itineraryItemDay || ""}
                    itineraryFeatureImageSourceUrl={
                      itinerary?.itineraryItemImage?.sourceUrl || ""
                    }
                    itineraryActivityList={
                      itinerary?.itineraryItemActivities?.map((item) => {
                        return {
                          desc: item?.itineraryItemActivitiesDesc || ""
                        };
                      }) || []
                    }
                  />
                );
              })}
            </ConditionalSwiper>
          </div>

          <div className="py-10 flex flex-col gap-5">
            <h6 className="w-full font-light text-generic-text planet:font-bold text-xl md:text-xlrg-sm planet:!text-white">
              {itineraryDetails?.sub_section_title}
            </h6>
            <div
              className="w-full text-mob md:text-base text-generic-text planet:text-gray-generic"
              dangerouslySetInnerHTML={{
                __html: itineraryDetails?.sub_section_desc
              }}
            />
            {itineraryDetails?.itinerary_file && (
              <div className="w-full">
                <CtaButton
                  preset="secondary"
                  ctaLabel="Download full itinerary"
                  showArrowIcon={false}
                  showAsButton={true}
                  labelClass="px-2 text-base leading-genericCta font-bold"
                  onClick={() => setBrochureDownloadModal(true)}
                  extraButtonStyle="w-full sm:w-auto"
                />
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default ProgramJourneysItinerary;
